<template>
    <div class="layout">
        <site-header></site-header>
        <router-view />
        <site-footer></site-footer>
    </div>
</template>

<script>
import siteHeader from './comps/site-header.vue';
import siteFooter from './comps/site-footer.vue';
export default {
    name: 'Layout',
    components: {
        siteHeader,
        siteFooter
    }
}
</script>

<style>
.layout{
    width: 100%;
}
</style>